// Copy keys `pages.program.spots_left.*` ship via the CDN web.json (GT-4770) — this experiment
// must not start until L10N has uploaded them, or every string renders as a raw key.
import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_spots_left~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_spots_left/__b'),
			},
		},
	},
]

export default config
